export const GA_MEASUREMENT_ID = 'G-QQVBQTQPHN';
export const CONSENT_STORAGE_KEY = 'curateed_cookie_consent';
export const COOKIE_SETTINGS_EVENT = 'curateed:open-cookie-settings';

// The site shows no ads, so only analytics_storage is ever granted.
const CONSENT_ANALYTICS_ONLY = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'granted'
};

const CONSENT_DENIED = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied'
};

const DISABLE_FLAG = `ga-disable-${GA_MEASUREMENT_ID}`;

let analyticsEnabled = false;
let scriptRequested = false;
let pendingPageView = null;

// GA requires the real `arguments` object to be pushed onto the dataLayer.
function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function clearAnalyticsCookies() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const domains = ['', hostname];
  if (parts.length > 1) domains.push(`.${parts.slice(-2).join('.')}`);

  document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0].trim())
    .filter((name) => name === '_ga' || name === '_gid' || name.startsWith('_ga_'))
    .forEach((name) => {
      domains.forEach((domain) => {
        const domainPart = domain ? `; domain=${domain}` : '';
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainPart}`;
      });
    });
}

// Called when the visitor accepts (or has previously accepted) cookies.
export function grantAnalytics() {
  if (typeof window === 'undefined') return;
  analyticsEnabled = true;
  window[DISABLE_FLAG] = false;
  gtag('consent', 'update', { ...CONSENT_ANALYTICS_ONLY });

  if (!scriptRequested) {
    scriptRequested = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  }

  if (pendingPageView) {
    gtag('event', 'page_view', pendingPageView);
    pendingPageView = null;
  }
}

// Called when the visitor declines or withdraws consent.
export function revokeAnalytics() {
  if (typeof window === 'undefined') return;
  analyticsEnabled = false;
  pendingPageView = null;
  window[DISABLE_FLAG] = true;
  gtag('consent', 'update', { ...CONSENT_DENIED });
  clearAnalyticsCookies();
}

export function trackPageView({ path, title, location }) {
  if (typeof window === 'undefined') return;
  const params = {
    page_location: location,
    page_path: path,
    page_title: title
  };

  if (!analyticsEnabled) {
    // Held in memory only; sent if the visitor accepts on this page.
    pendingPageView = params;
    return;
  }

  pendingPageView = null;
  gtag('event', 'page_view', params);
}

export function trackAffiliateClick({ course, placement, collectionSlug }) {
  if (typeof window === 'undefined' || !analyticsEnabled || !course) return;
  gtag('event', 'affiliate_click', {
    course_title: course.title || '',
    course_platform: course.platform || '',
    collection_slug: collectionSlug || '',
    link_url: course.affiliate_url || '',
    placement
  });
}

export function openCookieSettings() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}